import { pointer, timeDay } from "d3";
import { useState } from "react";
import { Tooltip } from "./Tooltip";
import { addDays, tickerFormatter } from "./utils/timeFormatters";

const getColorBasedOnWeekDay = (timestamp: number, idx: number) => {
    const date = new Date(timestamp);
    const weekDay= date.getDay();
    if(weekDay == 0 || weekDay == 6) {
        return 'fill-black'
    }

    return idx % 2 == 0 ? 'fill-zinc-200 hover:fill-cyan-200' : 'fill-white hover:fill-cyan-200';

}


export function Axis({ xScale, innerHeight }: any) {

    let tto : any;

    const [toolTip, setTooltip] = useState(false);

    const [triggeredTimeout, setTriggeredTimeout] = useState<any>(null);

    const axisYMargin = 50;

    const x1 = xScale(xScale.ticks(timeDay.every(1))[0]);
    const x2 = xScale(xScale.ticks(timeDay.every(1))[1]);
    const width : string = (x2 - x1).toFixed(2);

    const [mousePosition, setMousePosition] = useState<any>({x: null, y: null});

    const onMouseMove = (e : any) => {
            setMousePosition({...{x: pointer(e)[0], y: pointer(e)[1]}});
    }


    const onMouseLeave = () => {
        clearTimeout(triggeredTimeout);
        setTooltip(false);
    }

    const onMouseEnter = () => {

        tto = setTimeout(()=> {
            setTooltip(true);
        },300)

        setTriggeredTimeout(tto);
    } 

    const buildTooltipMessage = () => {
        return `${tickerFormatter(xScale.invert(mousePosition.x).getTime())}`
    }

    return (
        <g onMouseMove={onMouseMove}>
        {xScale.ticks(timeDay.every(1)).map((tickVal: any, idx: number) => {
           
            
            return (
                <g  onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className="tick" key={tickVal} transform={`translate(${xScale(tickVal)}, 0)`}>
                    <text
                        className="text-xs"
                        fill={'#C0C0BB'}
                        transform={`translate(${parseFloat(width) / 2 -4}, ${axisYMargin -5}) rotate(-40)`}
                    >{tickerFormatter(tickVal)}</text>
                    {/* <line
                        y1={axisYMargin}
                        y2={innerHeight - axisYMargin}
                        stroke={'#C0C0BB'}
                    /> */}
                    <rect
                        className={`opacity-40 ${getColorBasedOnWeekDay(tickVal, idx)} `}
                        y={axisYMargin}
                        width={width}
                        height={innerHeight - 2 * axisYMargin}
                      
                    />

                    <text
                        className="text-xs"
                        fill={'#C0C0BB'}
                        transform={`translate(${parseFloat(width) / 2 - 4}, ${innerHeight - axisYMargin + 10}) rotate(40)`}
                    >{tickerFormatter(tickVal)}</text>
                </g>)

        })}
        {toolTip ? <Tooltip size={'xs'} position="top" message={buildTooltipMessage()} x={mousePosition.x} y={mousePosition.y} height={40} width={70}/> : null}

        </g>
    )

}